export const APP_LOG_PROPS = {
  HEADING: 'Application Logs',
  SUB_HEADING: 'View and manage device application log records',
  LABELS: {
    LOG_ID: 'Log ID',
    DEVICE_ID: 'Device ID',
    OPERATOR_ID: 'Operator ID',
    MARKET_ID: 'Market ID',
    FILE_NAME: 'Filename',
    STATUS: 'Status',
    STATUS_CODE: 'Status Code',
    CREATED_ON: 'Created On',
    OPERATOR_INFO: 'Operator Info',
    DOWNLOAD: 'Download',
  },
  FILTERS: {
    STATUS: 'Select Status',
  },
  DOWNLOAD_TOOLTIPS: {
    DOWNLOADING: 'Downloading…',
    UPLOADING: 'File uploading…',
    FAILED: 'Upload failed',
    DEFAULT: 'Download log file',
    DISABLED: 'Log not ready for download',
  },
};

export const APP_LOG_STATUS_VALUES = {
  ACCEPTED: 'ACCEPTED',
  FAILED: 'FAILED',
  PROCESSED: 'PROCESSED',
};

export const APP_LOG_STATUS_CODES = {
  ACCEPTED: 100,
  FAILED: 400,
  PROCESSED: 0,
};

export const APP_LOG_STATUS = [
  { id: 'ALL', name: 'All Status' },
  { id: APP_LOG_STATUS_VALUES.ACCEPTED, name: 'Accepted' },
  { id: APP_LOG_STATUS_VALUES.FAILED, name: 'Failed' },
  { id: APP_LOG_STATUS_VALUES.PROCESSED, name: 'Processed' },
];
